import { render, staticRenderFns } from "./FormularioValvulaSig.vue?vue&type=template&id=27a97635&scoped=true&"
import script from "./FormularioValvulaSig.vue?vue&type=script&lang=js&"
export * from "./FormularioValvulaSig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a97635",
  null
  
)

export default component.exports